import { memo } from 'react';

import { type ScopedPermissions, type ShortUrlResponse } from '@air/api/types';

import { useUpdateShareBoardLink } from '~/components/SharePrivateBoardModal/hooks/useUpdateShareBoardLink';
import { SharePrivateContentSettings } from '~/components/SharePrivateContentModal/SharePrivateContentSettings/SharePrivateContentSettings';

type SharePrivateBoardSettingsProps = {
  boardId: string;
  shortIdInfo: ShortUrlResponse;
  userPermissions: ScopedPermissions;
};

export const SharePrivateBoardSettings = memo(
  ({ shortIdInfo, boardId, userPermissions }: SharePrivateBoardSettingsProps) => {
    const { onShortUrlUpdate, isLoading } = useUpdateShareBoardLink({ boardId, shortIdInfo });

    return (
      <SharePrivateContentSettings
        shortIdInfo={shortIdInfo}
        onShortUrlUpdate={onShortUrlUpdate}
        isLoading={isLoading}
        userPermissions={userPermissions}
      />
    );
  },
);
SharePrivateBoardSettings.displayName = 'SharePrivateBoardSettings';
